import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import isMobile from './utils/checkUserAgent';
import './scss/Header.scss';

function Header() {

  const [darkMode, setDarkMode] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(0);
  const mobile = isMobile();

  useEffect(() => {
    const mql = window.matchMedia('(prefers-color-scheme: dark)')
    mql.onchange = (e) => {
      if (e.matches) {
        setDarkMode(true)
      } else {
        setDarkMode(false)
      }
    };
  }, [])

  function toggleDarkMode() {
    setDarkMode(!darkMode)
  }

  function toggleMenu() {
    setMenuIsOpen(!menuIsOpen)
  }

  function DarkModeToggle() {
    return (
      <button 
        className="iconLabel"
        id="darkModeToggle" 
        onClick={toggleDarkMode} 
        data-theme-dark={darkMode}
      >
        <span className="icon"></span>
        <label>Dark mode</label>
      </button>
    );
  }

  return(
    <header id="site-header">
      <div className="header-container">
        <div className="left"></div>
        <Link to="/" className="center">
          <h4>
            <span>Randy's recipes:</span>
            <span className="family light">Easy Italian Cooking</span>
          </h4>
        </Link>
        <div className="right">
          {!mobile && <DarkModeToggle />}
          <button className="icon" id="main-menu-button" onClick={toggleMenu}></button>
        </div>
      </div>
      {menuIsOpen ? 
        <menu>
          <section>
            <input placeholder="Search recipes" type="text" id="search"></input>
            <nav>
              <ul>
                <li>Home</li>
                <li>All recipes</li>
                <li>About</li>
              </ul>
            </nav>
          </section>
          {mobile && <section><DarkModeToggle /></section>}
        </menu>
      : null }
    </header>
  )
}

export default Header;